/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-layout row wrap>
      <Toolbar dense class="mt-1 mr-1 ml-1">
        <div class="d-flex">
          <div class="mr-4 subheading">{{ $t('MFM List') }}</div>
          <div class="body-1" v-if="selectedBlock && selectedBlock.text">
            [ {{ selectedBlock.text }} ]
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="body-1">
          {{ show_date }}
        </div>
      </Toolbar>
      <v-flex xs12 sm12 md4 lg4 xl4>
        <Cards v-if="activeFilter.Date" :plantId="plantId" :blockId="selectedBlock ? selectedBlock.id : ''"
          :date="activeFilter.Date.from" v-on:initalGraph="loadCardData"
          v-on:onClickCard="onCardClick" :key="reloadComponent"></Cards>
      </v-flex>
      <v-flex xs12 sm12 md8 lg8 xl8>
        <GlobalGraph :key="graphReload" class="graph" v-if="series.length" :series="computedSeries" :xAxisData="xAxis"
          :yAxis="yAxis" :theme="theme" :loading="loading" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  mapGettersMixin
} from '@/util/mixin/index'
import list from '@/services/mfm.js'
import CommonApi from "@/services/Common"
import { mapGetters, mapMutations } from 'vuex'
import GlobalGraph from '@/components/common/GlobalGraph'
import Cards from '@/components/mfm/MfmCard'
const moment = require('moment')
const momentTz = require('moment-timezone')

export default {
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [ mapGettersMixin ],
  components: {
    Cards,
    GlobalGraph
  },
  data() {
    return {
      enableWatch: false,
      graphData: [],
      reloadComponent: 0,
      graphReload: 0,
      plantId: 0,
      loading: false,
      subscriptionMessage: 'This feature is not applicable for your plant.',
      series: [],
      xAxis: [],
      yAxis: [{ type: 'value' }],
      tempData: '',
      blockList: [],
      activeFilter: {},
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getGeneralState', 'getActivePlantTimezone']),
    filter() {
      return [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          id: "blockId",
          type: "select",
          title: "Select Block",
          considerStateAlways: true,
          value: this.blockList,
          condition: () => this.blockList.length > 1,
        },
      ]
    },
    show_date() {
      return this.activeFilter.Date ? moment(this.activeFilter.Date.from).format('YYYY/M/D') : ''
    },
    selectedBlock() {
      return this.activeFilter.blockId ? this.activeFilter.blockId : ''
    },
    currentLanguage() {
      return this.getGeneralState('language')
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series)
      return cloneSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    }
  },
  async created() {
    this.initialStates()
    await this.initialConfigList()
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT'
    ]),
    async initialConfigList() {
      const response = await this.getMfmBlockList()
      this.blockList = response.data.message
      const Obj = {}
      const cloneFilterOption = _.cloneDeep(this.filter);
      cloneFilterOption.forEach(child => {
        if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
          if (child.type === 'select') {
            if (typeof child.value === 'function') {
              Obj[child.id] = child.value(Obj[child.ref])
            } else {
              Obj[child.id] = child.value[0]
            }
          } else if (child.type === 'singleDatePicker') {
            let parameters = ['from', 'to']
            parameters.forEach(key => {
              if (!Obj[child.id]) { Obj[child.id] = {} }
              Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
            })
          } else {
            Obj[child.id] = child.value
          }
        }
      })
      this.activeFilter = Obj;
      this.$emit("filter:config", cloneFilterOption);
      this.$emit('initial:active_filter', Obj)
    },
    initialStates() {
      this.enableWatch = false
      this.plantId = this.getSelectedPlantId
      this.tempData = ''
    },
    async callAllApi(val) {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      await this.getGraphData(val)
    },
    onCardClick(val) {
      this.tempData = val
      this.callAllApi(val)
    },
    async loadCardData(value) {
      this.tempData = value[0]
      this.$set(this.graphData, 0, value)
      await this.setIntervalWithoutDelay(() => this.callAllApi(this.tempData))
    },
    async getGraphData(value) {
      this.loading = true
      let response = await list.getMfmData({
        plantId: this.plantId,
        query: `${value.block_id}-${value.feeder_id}`,
        date: this.activeFilter.Date.from
      })
      let data = response.data.message
      this.enableWatch = true
      this.series = [...data.graph]
      this.xAxis = [...data.xAxis]
      this.loading = false
    },
    async getMfmBlockList() {
      return new Promise(async (resolve, reject) => {
        const response = await CommonApi.getDeviceBlockList(this.getSelectedPlantId, 'mfm');
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(new Error(response));
        }
      });
    }
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    async getSelectedPlantId() {
      this.initialStates()
      await this.initialConfigList()
      this.reloadComponent += 1
    },
    isReload() {
      if (this.isReload) {
        this.reloadComponent += 1
      }
    },
    show_date(val) {
      if (val == '') {
        return
      }
      let currentDate = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
      if (this.enableWatch) {
        this.reloadComponent += 1
        if (moment(this.activeFilter.Date.from).diff(currentDate, 'days') > 0) {
          let payload = {
            icon: 'error',
            message: 'Please enter a valid date to view dashboard'
          }
          this.SET_SNACKBAR_CONTENT(payload)
          this.SET_SHOW_SNACKBAR(true)
        } else {
          if (this.tempData) {
            this.reloadComponent += 1
          }
        }
      }
    },
    selectedBlock(val, oldVal) {
      if (this.enableWatch) {
        if (val != '' && oldVal != '') {
          this.reloadComponent += 1
        }
      }
    },
    currentLanguage() {
      graphReload += 1
    }
  }
}
</script>
<style scoped>
.graph {
  width: 100%;
  height: calc(100vh - 296px)
}
</style>
